import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PlayerState {
  name: string;
  /** Server-seitige Player-ID (nanoid), wird per `session:identity` gesetzt */
  id: string | null;
  setName: (name: string) => void;
  setId: (id: string | null) => void;
}

export const usePlayerStore = create<PlayerState>()(
  persist(
    (set) => ({
      name: "",
      id: null,
      setName: (name) => set({ name }),
      setId: (id) => set({ id }),
    }),
    {
      name: "spieleparadies.player",
      partialize: (state) => ({ name: state.name }),
    },
  ),
);
